<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
<span [pTooltip]="$.row[$.adata.keyName]" class="cursor-pointer" (click)="onGoToRoute($.adata?.uri,$.row.id)" >{{$.row[$.adata.keyName].toString().length >24? (($.row[$.adata.keyName] | slice:0:24 )+'...'):$.row[$.adata.keyName]}}</span>
</ng-container>
